import React from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { FormattedMessage } from "react-intl";

import { Button } from "src/common/components/Button";
import { genericMessages } from "src/messages/generic";

import "./FieldGroupList.css";

export const FieldGroupList: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="field-group-list">{children}</div>;

interface FieldGroupListItemProps {
	body: React.ReactNode;
	footer: React.ReactNode;
}

export const FieldGroupListItem: React.FunctionComponent<
	FieldGroupListItemProps
> = ({ body, footer }) => (
	<div className="field-group-list-item">
		<div className="field-group-list-item__body">{body}</div>
		<div className="field-group-list-item__footer">{footer}</div>
	</div>
);

interface AddFirstButtonProps {
	disabled?: boolean;
	onClick(): unknown;
}

export const AddFirstButton: React.FunctionComponent<AddFirstButtonProps> = ({
	disabled,
	onClick
}) => (
	<Button
		type="button"
		disabled={disabled}
		variant="secondary"
		onClick={onClick}
	>
		<FormattedMessage {...genericMessages.add} />
	</Button>
);

interface RemoveButtonProps {
	disabled?: boolean;
	onClick(): unknown;
}

export const RemoveButton: React.FunctionComponent<RemoveButtonProps> = ({
	disabled = false,
	onClick
}) => (
	<Button
		variant="secondary"
		type="button"
		onClick={onClick}
		disabled={disabled}
	>
		<FaMinus />
	</Button>
);

interface AddButtonProps {
	disabled?: boolean;
	onClick(): unknown;
}

export const AddButton: React.FunctionComponent<AddButtonProps> = ({
	disabled = false,
	onClick
}) => (
	<Button
		variant="secondary"
		type="button"
		onClick={onClick}
		disabled={disabled}
	>
		<FaPlus />
	</Button>
);
